export default class CoordinateFilter {
  filter(coord) {}
}
